module.exports = __webpack_public_path__ + "resources/img/equipment_tab4_img3.1e83a25077ff6e36e34ada13c51c9fd8.jpg";